module.exports = __webpack_public_path__ + "media/kuala lumpur/nyonya-c77144ad.jpg";